import { useEffect, useState } from 'react'
import { useLocation, useNavigate, useRoutes } from 'react-router-dom'
import { protectedRoutes } from './protected'
import { publicRoutes } from './public'
import { useLoginStatus } from 'src/hooks/useLoginStatus'
import { AUTH_ROUTES, PUBLIC_ROUTES, VIEWER_FORBIDDEN_ROUTES } from 'Consts/routeNames'
import { useAppStore } from 'Stores/appStoreModuleFed'
import { useUserStore } from 'Stores/userStoreModuleFed'

export const AppRoutes = () => {
  const { pathname } = useLocation()

  const { isLoggedIn } = useLoginStatus()
  const navigate = useNavigate()
  const location = useLocation()
  const [prevPathname, setPrevPathname] = useState('')

  // don't render protected routes if user is not logged in
  const showProtectedRoutes = isLoggedIn ? protectedRoutes : []

  const combinedRoutes = [...showProtectedRoutes, ...publicRoutes]
  const { noCcSaveSubscriptionInProgress, isAuthenticating } = useAppStore()
  const { owner } = useUserStore()

  const routes = useRoutes(combinedRoutes)
  useEffect(() => {
    // Check for changes in location.pathname
    if (location.pathname !== prevPathname) {
      // Mixpanel segment page logging
      if (window.analytics) {
        const pageName = location.pathname === '/' ? 'Home' : location.pathname.substring(1)
        window.analytics.page(pageName)
      }
      setPrevPathname(location.pathname)
    }
    // eslint-disable-next-line
  }, [location.pathname])

  useEffect(() => {
    // if user logged-in in non-protected route, redirect to home
    if (
      isLoggedIn &&
      !noCcSaveSubscriptionInProgress &&
      AUTH_ROUTES.includes(pathname.substring(1)) &&
      !isAuthenticating &&
      !location.state
    ) {
      navigate('/')
    }
    // in case user is not logged in, redirect to login page with sate for deep linking
    if (!isLoggedIn && !PUBLIC_ROUTES.includes(pathname.substring(1))) {
      navigate('/login', {
        state: { redirect: pathname },
      })
    }
    // Route guard- redirect user to home if user is a viewer and is trying to access
    // owner only routes
    if (!owner && VIEWER_FORBIDDEN_ROUTES.includes(location.pathname)) {
      navigate('/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, isLoggedIn])

  return routes
}
